export default {
  info_modal: {
    button_title: 'Continua',
  },
};
